import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";

export const ModalComponentDelete = ({
  title,
  body,
  cancelBtnText,
  primaryBtnText,
  primaryClick,
  modalID,
}) => {
  return (
    <div
      className="modal fade"
      id={modalID}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {title}
            </h1>
          </div>
          <div className="modal-body">{body}</div>
          <div className="modal-footer">
            <Button
              variant="text"
              data-bs-dismiss="modal"
              sx={{ marginRight: "10px" }}
            >
              {cancelBtnText}
            </Button>
            <Button
              variant="contained"
              color="error"
              data-bs-dismiss="modal"
              onClick={primaryClick}
            >
              {primaryBtnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export const AlertDialog = ({
  open,
  handleClose,
  title,
  body,
  primaryBtnText,
  primaryClick,
  cancelBtnText,
}) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{cancelBtnText}</Button>
        <Button onClick={primaryClick}>{primaryBtnText}</Button>
      </DialogActions>
    </Dialog>
  );
};

export const ProgressDialog = ({ loading, message }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={loading}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress
          color="inherit"
          value={10}
          sx={{ marginBottom: "15px" }}
        />
        <Typography>{message}</Typography>
      </Grid>
    </Backdrop>
  );
};

export const ShowSnackBar = ({openSnackBar,handleCloseSnackBar,message,type}) => {
  return (
    <Snackbar
      open={openSnackBar}
      autoHideDuration={6000}
      onClose={handleCloseSnackBar}
    >
      <Alert
        onClose={handleCloseSnackBar}
        severity={type}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
